import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, BasicTooltip, toast, ExpandedTooltip } from '@livable/saas-react-components';
import { TableHead, TableBody, TableRow, TableCell, Button, Typography } from '@mui/material';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { BatchDueReminderModal } from 'src/components/unit/BatchDueReminderModal';
import { currencyFormatter } from 'src/utils/translator';
import { isValueNumber } from 'src/utils/typeValidators';
import SendReportModal from 'src/pages/ARPage/SendReportModal';
export default function RowV2(_ref) {
  let data = _ref.data,
    getPropertyById = _ref.getPropertyById,
    companyReportTotalUnpaid = _ref.companyReportTotalUnpaid,
    isDisabled = _ref.isDisabled,
    _ref$propertyOptions = _ref.propertyOptions,
    propertyOptions = _ref$propertyOptions === void 0 ? [] : _ref$propertyOptions;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const canUseHolderOnlyActions = store.account.userProfile.isUserPmHolderOrHigher;
  const residents = data.residents;
  const handleDownloadBatchReport = async (e, propertyIds) => {
    e.stopPropagation();
    const getFileName = headers => {
      var _headers$fileName;
      return (_headers$fileName = headers['file-name']) !== null && _headers$fileName !== void 0 ? _headers$fileName : null;
    };
    const _await$store$report$d = await store.report.downloadCombinedPropertiesReportAsync.run({
        propertyIds: propertyIds
      }),
      downloadedFile = _await$store$report$d.data,
      headers = _await$store$report$d.headers;
    const encodedUri = window.URL.createObjectURL(new Blob([downloadedFile], {
      type: 'application/octet-stream'
    }));
    let link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', getFileName(headers));
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };
  const sendReminderToAllTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    state: "active",
    'custom-attribute': '793-reporting-page-reimbursement-tab-v2'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('reimbursement_dashboard.reminder_all')));
  const handleSendBalanceRemainder = async currentAccountId => {
    setIsLoading(true);
    const resp = await store.payment.sendBalanceRemainderAsync.run({
      accountId: currentAccountId
    });
    if (resp && resp.isSuccessful) {
      toast('success', {
        body: ['Successfully sent']
      });
    }
    setIsLoading(false);
  };
  const getOldestDebt = _ref2 => {
    let dayMonthPeriod = _ref2.dayMonthPeriod,
      oneMonthTwoMonthPeriod = _ref2.oneMonthTwoMonthPeriod,
      twoMonthThreeMonthPeriod = _ref2.twoMonthThreeMonthPeriod,
      moreThreeMonthPeriod = _ref2.moreThreeMonthPeriod;
    if (isValueNumber(moreThreeMonthPeriod) && moreThreeMonthPeriod > 0) {
      return t('reimbursement_dashboard.ninety_plus');
    } else if (isValueNumber(twoMonthThreeMonthPeriod) && twoMonthThreeMonthPeriod > 0) {
      return t('reimbursement_dashboard.sixty_ninety_days');
    } else if (isValueNumber(oneMonthTwoMonthPeriod) && oneMonthTwoMonthPeriod > 0) {
      return t('reimbursement_dashboard.thirty_sixty_days');
    } else if (isValueNumber(dayMonthPeriod) && dayMonthPeriod > 0) {
      return t('reimbursement_dashboard.one_thirty_days');
    }
  };
  const UnpaidTooltip = _ref3 => {
    let dataUnpaidTooltip = _ref3.dataUnpaidTooltip;
    const total = dataUnpaidTooltip.total,
      currentPeriod = dataUnpaidTooltip.currentPeriod,
      dayMonthPeriod = dataUnpaidTooltip.dayMonthPeriod,
      oneMonthTwoMonthPeriod = dataUnpaidTooltip.oneMonthTwoMonthPeriod,
      twoMonthThreeMonthPeriod = dataUnpaidTooltip.twoMonthThreeMonthPeriod,
      moreThreeMonthPeriod = dataUnpaidTooltip.moreThreeMonthPeriod;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.arTooltipContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: "tooltip-header"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, t('reimbursement_dashboard.resident_unpaid'), ":")), /*#__PURE__*/React.createElement("div", {
      className: "tooltip-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.arTooltip
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body4"
    }, t('reimbursement_dashboard.current')), /*#__PURE__*/React.createElement(Typography, {
      variant: "body4",
      className: classes.arTooltipRowValue
    }, currencyFormatter(Number(currentPeriod)))), /*#__PURE__*/React.createElement("div", {
      className: classes.arTooltip
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body4"
    }, t('reimbursement_dashboard.one_thirty_days')), /*#__PURE__*/React.createElement(Typography, {
      variant: "body4",
      className: classes.arTooltipRowValue
    }, currencyFormatter(Number(dayMonthPeriod)))), /*#__PURE__*/React.createElement("div", {
      className: classes.arTooltip
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body4"
    }, t('reimbursement_dashboard.thirty_sixty_days')), /*#__PURE__*/React.createElement(Typography, {
      variant: "body4",
      className: classes.arTooltipRowValue
    }, currencyFormatter(Number(oneMonthTwoMonthPeriod)))), /*#__PURE__*/React.createElement("div", {
      className: classes.arTooltip
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body4"
    }, t('reimbursement_dashboard.sixty_ninety_days')), /*#__PURE__*/React.createElement(Typography, {
      variant: "body4",
      className: classes.arTooltipRowValue
    }, currencyFormatter(Number(twoMonthThreeMonthPeriod)))), /*#__PURE__*/React.createElement("div", {
      className: classes.arTooltip
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body4"
    }, t('reimbursement_dashboard.ninety_plus')), /*#__PURE__*/React.createElement(Typography, {
      variant: "body4",
      className: classes.arTooltipRowValue
    }, currencyFormatter(Number(moreThreeMonthPeriod))))), /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.arTooltipTotal)
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, t('reimbursement_dashboard.total_unpaid_static'), ":"), /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      className: classes.arTooltipRowValue
    }, currencyFormatter(Number(total)))));
  };
  return /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, {
    key: 'AR-header'
  }, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.addressHeaderCell,
    colSpan: 3
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: t('reimbursement_dashboard.all_properties_total_unpaid', {
      totalUnpaid: currencyFormatter(companyReportTotalUnpaid)
    }),
    placement: "top"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('reimbursement_dashboard.all_properties_total_unpaid', {
    totalUnpaid: currencyFormatter(companyReportTotalUnpaid)
  })))), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    colSpan: 4,
    className: classes.arReportAction
  }, canUseHolderOnlyActions && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    disabled: isDisabled,
    onClick: e => handleDownloadBatchReport(e, Array.from(new Set(residents.map(i => i.propertyId)))),
    variant: "actionButton",
    className: 'arReportActionDownloadReport',
    'custom-attribute': '794-reporting-page-reimbursement-tab-v2'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "file-download"
  }), t('reimbursement_dashboard.download_report')), /*#__PURE__*/React.createElement(SendReportModal, {
    disabled: isDisabled,
    properties: propertyOptions.filter(i => i.isChosen) || []
  })), /*#__PURE__*/React.createElement(BatchDueReminderModal, {
    trigger: sendReminderToAllTrigger,
    exportedData: residents
  }))), /*#__PURE__*/React.createElement(TableRow, {
    key: 'AR-header-Residents'
  }, /*#__PURE__*/React.createElement(TableCell, null, t('reimbursement_dashboard.resident')), /*#__PURE__*/React.createElement(TableCell, null, t('reimbursement_dashboard.property')), /*#__PURE__*/React.createElement(TableCell, null, t('reimbursement_dashboard.unit')), /*#__PURE__*/React.createElement(TableCell, null, t('reimbursement_dashboard.contacts')), /*#__PURE__*/React.createElement(TableCell, null, t('reimbursement_dashboard.oldest_debt')), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.totalCell
  }, t('reimbursement_dashboard.total_unpaid_static')), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.actionCell,
    align: "right"
  }, t('reimbursement_dashboard.action')))), /*#__PURE__*/React.createElement(TableBody, null, (residents === null || residents === void 0 ? void 0 : residents.length) && residents.map(resident => {
    return _objectSpread(_objectSpread({}, resident), getPropertyById(resident.propertyId));
  }).sort((a, b) => {
    var _ref5;
    if ((a === null || a === void 0 ? void 0 : a.propertyAddress) === (b === null || b === void 0 ? void 0 : b.propertyAddress)) {
      var _ref4;
      return (_ref4 = '' + (a === null || a === void 0 ? void 0 : a.unitName)) === null || _ref4 === void 0 ? void 0 : _ref4.localeCompare(b === null || b === void 0 ? void 0 : b.unitName, undefined, {
        numeric: true
      });
    }
    return (_ref5 = '' + (a === null || a === void 0 ? void 0 : a.propertyAddress)) === null || _ref5 === void 0 ? void 0 : _ref5.localeCompare(b === null || b === void 0 ? void 0 : b.propertyAddress, undefined, {
      numeric: true
    });
  }).map(resident => /*#__PURE__*/React.createElement(TableRow, {
    key: (resident === null || resident === void 0 ? void 0 : resident.propertyId) + (resident === null || resident === void 0 ? void 0 : resident.unitName)
  }, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.residentCell
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: resident.residentFullName,
    placement: "top"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, resident.residentFullName))), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.addressCell
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: resident.propertyAddress,
    placement: "top"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, resident === null || resident === void 0 ? void 0 : resident.propertyAddress))), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.unitCell,
    align: 'center'
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: resident === null || resident === void 0 ? void 0 : resident.unitName,
    placement: "top"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, resident.unitName))), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.contactsCell
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: resident !== null && resident !== void 0 && resident.emailAddress ? ' ' + resident.emailAddress : ' N/A',
    placement: "top"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, resident !== null && resident !== void 0 && resident.emailAddress ? ' ' + resident.emailAddress : ' N/A')), /*#__PURE__*/React.createElement(BasicTooltip, {
    title: resident !== null && resident !== void 0 && resident.phone ? ' ' + resident.phone : ' N/A',
    placement: "top"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, resident !== null && resident !== void 0 && resident.phone ? ' ' + resident.phone : ' N/A'))), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.debtPeriodCell
  }, getOldestDebt(resident)), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: /*#__PURE__*/React.createElement(UnpaidTooltip, {
      dataUnpaidTooltip: resident
    }),
    type: "utilities-error",
    placement: "top"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '795-reporting-page-reimbursement-tab-v2'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText ".concat(classes.residentTotal)
  }, resident !== null && resident !== void 0 && resident.total ? "$".concat(Number(resident === null || resident === void 0 ? void 0 : resident.total).toFixed(2)) : 'N/A'), /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-line-down"
  })))), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: resident.emailAddress !== null ? t('reimbursement_dashboard.send_reminder_to', {
      emailAddress: resident.emailAddress
    }) : t('reimbursement_dashboard.send_reminder_no_resident_email'),
    placement: "top"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    disabled: isLoading || resident.emailAddress === null,
    onClick: () => {
      handleSendBalanceRemainder(resident.accountId);
    },
    'custom-attribute': '796-reporting-page-reimbursement-tab-v2'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('reimbursement_dashboard.send_reminder'))))))))));
}